module.exports = __webpack_public_path__ + "img/8d8cd0bdfb45b56b6c32cbbfca688b3d.png";